<template>
  <section class="bg-white rounded-lg border border-geyser p-5 md:p-8">
    <div class="flex flex-col space-y-6">
      <div
        class="
          flex flex-col space-y-5
          md:flex-row md:items-start md:justify-between
          md:space-x-8 md:space-y-0
        ">
        <div class="flex flex-col space-y-3 max-w-2xl">
          <div class="inline-flex items-center space-x-2">
            <span
              class="
                inline-flex items-center justify-center
                w-9 h-9 rounded-full bg-primary text-white
                text-20px leading-20px font-bold
              ">
              ✓
            </span>
            <h2 class="text-22px leading-26px font-bold text-primary">
              Заявка принята
            </h2>
          </div>

          <p class="text-15px leading-22px text-inverse">
            Спасибо. Телефон подтверждён, данные отправлены в iWALY.
            Дальше заявка проходит проверку и ручное подключение исполнителя.
          </p>
        </div>

        <div
          class="
            flex flex-row items-center justify-center space-x-3
            rounded-lg border border-geyser bg-hint px-5 py-4
            md:flex-col md:space-x-0 md:space-y-3
          ">
          <div class="w-8 h-8 rounded-full bg-primary shadow"></div>
          <div class="w-8 h-8 rounded-full bg-warning shadow opacity-80"></div>
          <div class="w-8 h-8 rounded-full bg-muted shadow opacity-70"></div>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div class="rounded-lg border border-primary bg-hint p-4">
          <div class="flex items-center space-x-2 mb-2">
            <span class="w-3 h-3 rounded-full bg-primary"></span>
            <strong class="text-15px leading-20px text-primary">
              1. Получено
            </strong>
          </div>
          <p class="text-13px leading-19px text-inverse">
            Мы получили вашу заявку, контактные данные, регион, город,
            выбранные услуги и комментарий.
          </p>
        </div>

        <div class="rounded-lg border border-geyser bg-white p-4">
          <div class="flex items-center space-x-2 mb-2">
            <span class="w-3 h-3 rounded-full bg-warning"></span>
            <strong class="text-15px leading-20px text-inverse">
              2. Проверяем
            </strong>
          </div>
          <p class="text-13px leading-19px text-inverse">
            При необходимости свяжемся с вами, уточним географию работ,
            категории услуг и условия сотрудничества.
          </p>
        </div>

        <div class="rounded-lg border border-geyser bg-white p-4">
          <div class="flex items-center space-x-2 mb-2">
            <span class="w-3 h-3 rounded-full bg-muted"></span>
            <strong class="text-15px leading-20px text-inverse">
              3. Подключаем
            </strong>
          </div>
          <p class="text-13px leading-19px text-inverse">
            После согласования активируем профиль исполнителя или оставим
            заявку в резерве и отдельно сообщим по SMS или email.
          </p>
        </div>
      </div>

      <div
        class="
          rounded-lg border border-primary bg-hint p-5
          text-14px leading-20px text-inverse
        ">
        <strong class="text-primary">Важно:</strong>
        <p class="mt-2">
          Эта форма не является мгновенной автоматической регистрацией в приложении.
          Это заявка на сотрудничество: мы обрабатываем обращения, проверяем данные
          и корректно подключаем исполнителей к сервису. Аккаунт может появиться
          не сразу, но обратная связь будет предоставлена.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContractorAfterForm',
};
</script>
